import { createSlice } from '@reduxjs/toolkit';
import { sendContactMessage } from './thunks';

export interface ContactFormState {
  sending?: boolean;
  sendingError?: string;
}

const initialState: ContactFormState = {
  sending: undefined,
  sendingError: undefined,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    resetState: (state) => {
      state.sending = initialState.sending;
      state.sendingError = initialState.sendingError;
    },
  },
  extraReducers: (builder) => {
    // sending contact form message
    builder.addCase(sendContactMessage.pending, (state) => {
      state.sending = true;
      state.sendingError = initialState.sendingError;
    });
    builder.addCase(sendContactMessage.fulfilled, (state, action) => {
      state.sending = false;
      state.sendingError = undefined;
    });
    builder.addCase(sendContactMessage.rejected, (state, action) => {
      state.sending = false;
      state.sendingError = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export const { resetState } = contactSlice.actions;

export default contactSlice.reducer;
